import { IAiAssistantSuggestedActionConfig } from "./types";

export enum AdminAiAssistantSuggestedAction {
  RUN_NEXT_SCHEDULED_PAYROLL = "RUN_NEXT_SCHEDULED_PAYROLL",
  INCREASE_HOURLY_RATE_FOR_EMPLOYEE = "INCREASE_HOURLY_RATE_FOR_EMPLOYEE",
  ADD_NEW_EMPLOYEE = "ADD_NEW_EMPLOYEE",
}

export const adminAiAssistantSuggestedActionsConfig: IAiAssistantSuggestedActionConfig[] = [
  {
    title: AdminAiAssistantSuggestedAction.RUN_NEXT_SCHEDULED_PAYROLL,
    textKey: `ai_assistant_pages.admin.ai_assistant_suggested_actions.${AdminAiAssistantSuggestedAction.RUN_NEXT_SCHEDULED_PAYROLL}`,
  },
  {
    title: AdminAiAssistantSuggestedAction.INCREASE_HOURLY_RATE_FOR_EMPLOYEE,
    textKey: `ai_assistant_pages.admin.ai_assistant_suggested_actions.${AdminAiAssistantSuggestedAction.INCREASE_HOURLY_RATE_FOR_EMPLOYEE}`,
  },
  {
    title: AdminAiAssistantSuggestedAction.ADD_NEW_EMPLOYEE,
    textKey: `ai_assistant_pages.admin.ai_assistant_suggested_actions.${AdminAiAssistantSuggestedAction.ADD_NEW_EMPLOYEE}`,
  },
];

export enum EmployeeAiAssistantSuggestedAction {
  LOG_TIME = "LOG_TIME",
}

export const employeeAiAssistantSuggestedActionsConfig: IAiAssistantSuggestedActionConfig[] = [
  {
    title: EmployeeAiAssistantSuggestedAction.LOG_TIME,
    textKey: `ai_assistant_pages.employee.ai_assistant_suggested_actions.${EmployeeAiAssistantSuggestedAction.LOG_TIME}`,
  },
];
